//
// language dropdown
//

export function langDropDown() {
  const $dropDown = $('.ui.dropdown');
  const $dropDownActiveLang = $dropDown.find('span.text');
  const curLang = '/' + $('html').attr('lang');

  if ($dropDown.is(':visible')) {
    $dropDown.dropdown(
      {
        onChange(value, text) {
          if (curLang !== value) {
            window.location.href = window.location.origin + value;
          }
        }
      }
    );

    $dropDown.removeClass('loading');
    $dropDownActiveLang.html($dropDown.find('.item[data-value="' + curLang + '"]').html());
  }
}

//
// mobile navigation
//

export function mobileNav() {
  const $nav = document.querySelector('.nav, .top-menu');
  const $mobileNav = document.querySelector('.mobile-nav');

  $mobileNav && $mobileNav.addEventListener('click', function(event) {
    $mobileNav.classList.toggle('open');
    $nav.classList.toggle('open');
  });

  window.onresize = () => {
    if (!$mobileNav) { return; }

    if (document.documentElement.scrollTop < $mobileNav.offsetHeight) { return; }

    $mobileNav.classList.remove('open');
    $nav.classList.remove('open');
  };

  //
  // Handle scrolling for mobile devices
  //

  let hasScrolled = false;

  if (document.querySelector('.mobile, .tablet')) {
    document.addEventListener('scroll', () => hasScrolled = true)
  }

  //
  // navigation sidebar behaviour when scroll happen
  //

  const onScroll = () => {
    hasScrolled = false;

    const $sidebar = document.querySelector('.nav');

    if (!$sidebar) { return; }

    if (document.documentElement.scrollTop > 0) {
      return $sidebar.style.top = '0px';
    }

    const offsetHeight = document.querySelector('header').offsetHeight - 1;

    $sidebar.style.top = offsetHeight + 'px';
  };

  setInterval(() => hasScrolled && onScroll(), 250);
}

export function handleOrganicMenuSubitems() {
  const $organicTopMenu = document.querySelector('.mobile .organic-template .top-menu .arrow, .tablet .organic-template .top-menu .arrow');
  const $organicTopMenuShowMore = document.querySelector('.organic-template .top-menu .showMoreItems');

  if ($organicTopMenu) {
    $organicTopMenu.addEventListener('click', event => {
      event.preventDefault();

      $organicTopMenu.closest('li').classList.toggle('open')
    });
  }

  if ($organicTopMenuShowMore) {
    $organicTopMenuShowMore.addEventListener('click', event => {
      event.preventDefault();

      let hiddenItems = $organicTopMenuShowMore.closest('ul').querySelectorAll('.hidden');
      hiddenItems.forEach(function (item) {
        item.classList.remove('hidden');
      });

      $organicTopMenuShowMore.classList.add('hidden');
    });
  }
}

//
// legacy gimmemore sub navigation, still using for desktop and tablet
//

export function gimmemoreSubNav() {
  const gmNav = document.querySelector('.gimmemore-nav');

  if (!gmNav) { return; }

  const classOpen = 'open';
  const classSubNavOpen = 'subnav-open';

  const gmPageWrapper = document.querySelector('body.gimmemore-theme > div');
  const gmNavMoreLink = gmNav.querySelector('.gm-nav-more');

  if (!gmNavMoreLink) { return; }

  const allSubNavs = gmNavMoreLink.closest('.gm-nav-more-item').querySelector('.gm-subnav-more');

  // open sub navigation if user is under specific category route on desktop device
  if (gmPageWrapper.classList.contains(classSubNavOpen) && gmPageWrapper.querySelector('.desktop')) {
    allSubNavs
      .closest(`.header-link-${gmPageWrapper.dataset.activeCategory}`)
      .classList
      .add(classOpen);
  }

  gmNavMoreLink.addEventListener('click', event => {
    const link = event.target.closest('.gm-nav-more')

    if (!document.querySelector('.desktop') && link.href.length) { return; }

    event.preventDefault();

    const currentMoreItem = link.closest('.gm-nav-more-item');
    const currentSubNav = currentMoreItem.closest('.gm-nav-more-item').querySelector('.gm-subnav-more');

    if (currentSubNav.classList.contains(classOpen)) {
      allSubNavs.classList.remove(classOpen);
      gmPageWrapper.classList.remove(classSubNavOpen);
    } else {
      allSubNavs.classList.remove(classOpen);
      currentSubNav.classList.add(classOpen);
      gmPageWrapper.classList.add(classSubNavOpen);
    }
  });
}

//
// Quiz-Universe nav
//

export function quizUniverseNav() {
  const quNav = document.querySelector('.quiz-universe-nav');

  if (!quNav) { return; }

  const classOpen = 'open';

  quNav.querySelectorAll('.nav-more').forEach((navItem) => {
    navItem.addEventListener('click', (e) => {
      e.preventDefault();
      let subNav = e.target.closest('.nav-more').nextElementSibling;

      quNav.querySelectorAll('.subnav-more').forEach((_item) => {
        if (_item.classList !== subNav.classList) {
          _item.classList.remove(classOpen);
        }
      });

      if (subNav.classList.contains('subnav-more') && !subNav.classList.contains('open')) {
        subNav.classList.add(classOpen);
      } else if (subNav.classList.contains('subnav-more') && subNav.classList.contains('open')) {
        subNav.classList.remove(classOpen);
      }
    });
  });
}

export function newGmmHomepageMenu() {
  let menuBurger = document.querySelector('[data-menu-button="burger"]');

  if (menuBurger) {
    let menuContainer = document.getElementById('gmmMobileMenu');
    let openMenuIcon = document.querySelector('[data-burger-open-icon]');
    let closeMenuIcon = document.querySelector('[data-burger-close-icon]');

    menuBurger.addEventListener('click', function (event) {
      event.preventDefault();

      openMenuIcon.classList.toggle('hidden');
      closeMenuIcon.classList.toggle('hidden');
      menuContainer.classList.toggle('hidden');
    });

    const onScroll = () => {
      if (document.documentElement.scrollTop > 0) {
        return menuContainer.style.top = '0px';
      }

      const offsetHeight = document.querySelector('header').offsetHeight - 1;

      menuContainer.style.top = offsetHeight + 'px';
    };

    document.addEventListener('scroll', () => onScroll());
  }

  let articlesTopMenuElement = document.querySelector('[data-articles-link]');
  let articlesMenuElement = document.getElementById('articlesMenu');

  if (articlesTopMenuElement) {
    articlesTopMenuElement.addEventListener('click', function (event) {
      event.preventDefault();

      articlesMenuElement.classList.toggle('opacity-0');
    });
  }
}